import styled from "styled-components";

export const ManageStoreWrapper = styled.div`
    .header {
        display: flex;
        justify-content: space-between;
        align-items: flex-start;
        flex-direction: column;
        gap: 20px;
        margin-bottom: 40px;
        @media (min-width: 575px) {
            flex-direction: row;
        }
        .left-warp {
            display: flex;
            justify-content: space-between;
            align-items: flex-start;
            flex-direction: column;
            gap: 20px;
            @media (min-width: 768px) {
                flex-direction: row;
            }
            .title {
                font-size: 16px;
                line-height: 20px;
                font-weight: 300;
                color: var(--gray);
                @media (min-width: 768px) {
                    font-size: 18px;
                    line-height: 22px;
                }
                h2 {
                    white-space: nowrap;
                }
            }
        }
        .btn-warp {
            span {
                svg {
                    width: 15px;
                    height: 15px;
                    border-radius: 3px;
                    padding: 2px;
                    background-color: #fff;
                    color: ${({theme}) => theme?.light?.primary};
                    margin-bottom: -2px;
                }
            }
        }
    }
`;
export const ManageBranchesWrapper = styled.div`
    /* box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.11);
border-radius: 25px;
padding: 15px 0; */
    .image-wrapper {
        width: 100%;
        max-width: 100px;
        height: 70px;
        border-radius: 10px;
        overflow: hidden;

        img {
            display: block;
            width: 100%;
            height: 100%;
            object-fit: cover;
        }
    }
    .action-btns {
        display: flex;
        gap: 15px;
        justify-content: flex-end;
        .edit-btn {
            svg {
                width: 25px;
                height: 25px;
                background-color: rgba(245, 126, 42, 0.2);
                padding: 5px;
                border-radius: 5px;
            }
        }
        .eye-btn {
            svg {
                width: 25px;
                height: 25px;
                background-color: rgba(236, 236, 236, 1);
                padding: 5px;
                border-radius: 5px;
            }
        }
        .delete-btn {
            svg {
                width: 25px;
                height: 25px;
                background-color: rgba(224, 0, 0, 0.2);
                color: #e00000;
                padding: 5px;
                border-radius: 5px;
            }
        }
    }
`;
